// extracted by mini-css-extract-plugin
module.exports = {"log-out-icon-wrapper":"LogOut_log-out-icon-wrapper__2Tvmn"};